<template>
  <div
    v-on="$listeners"
    v-bind="$attrs"
    :class="_class"
    :style="_style"
  >
    <slot />
  </div>
</template>

<script>
const name = 'ten-col';

export default {
  name,
  props: {
    /**
     * 所占列数
     */
    span: {
      type: Number,
      default: 1,
    },
    /**
     * 偏移
     */
    offset: {
      type: Number,
      default: 0,
    },
    /**
     * 栅格向左移动格数
     */
    pull: {
      type: Number,
      default: 0,
    },
    /**
     * 栅格向右移动格数
     */
    push: {
      type: Number,
      default: 0,
    },
    /**
     * 小于768px屏幕时的列配置，若提供数字则代表 span
     */
    xs: [Number, Object],
    /**
     * 768~992屏幕时的列配置，若提供数字则代表 span
     */
    sm: [Number, Object],
    /**
     * 992~1200屏幕时的列配置，若提供数字则代表 span
     */
    md: [Number, Object],
    /**
     * 1200~1920屏幕时的列配置，若提供数字则代表 span
     */
    lg: [Number, Object],
    /**
     * 大于1920屏幕时的列配置，若提供数字则代表 span
     */
    xl: [Number, Object],
    /**
     * @ignore
     */
    _gutter: Number, // eslint-disable-line
    /**
     * @ignore
     */
    _size: String, // eslint-disable-line
    /**
     * @ignore
     */
    _colCount: Number // eslint-disable-line
  },
  computed: {
    _class() {
      return [
        name,
      ];
    },
    _style() {
      const style = {
        width: `${(this._span / this._colCount).toFixed(6) * 100}%`,
        padding: `0 ${this._gutter / 2}px`,
      };

      const keyAttrMap = {
        offset: 'margin-left',
        push: 'left',
        pull: 'right',
      };
      Object.keys(this._position).forEach((key) => {
        if (this._position[key] !== 0) {
          style[keyAttrMap[key]] = `${(this._position[key] / this._colCount).toFixed(6) * 100}%`;
        }
      });
      return style;
    },
    _span() {
      if (this._size && this[this._size]) {
        const config = this[this._size];
        if (typeof config === 'number') {
          return config;
        }
        return config.span || this.span;
      }
      return this.span;
    },
    _position() {
      const keys = ['offset', 'push', 'pull'];
      const position = {};

      if (this._size && this[this._size]) {
        const config = this[this._size];
        if (typeof config === 'object') {
          keys.forEach((key) => {
            position[key] = config[key];
          });
        }
      }
      keys.forEach((key) => {
        position[key] = position[key] || this[key];
      });

      return position;
    },
  },
};
</script>
